import React, { useEffect } from 'react';
import Animated from 'components/generals/AnimatedComponent';
import pictures from 'assets/images/home/section_11/pictures.png';
import ActionButton from 'components/ui/buttons/action-button';
import Accordeon from 'components/ui/accordeon';
export default function Home__section__11() {
    return (
        <main className="nv__section nv__section--no-margin nv__hp__section__11">
            <section className="nv__section__container">
                <section className="section__block">
                    <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                        <h1>Explora las oportunidades</h1>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-2s'}>
                        <h3>
                            En la Industria de las raíces y <br />
                            tubérculos con ROOTSTOKEN
                        </h3>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-3s'}>
                        <p>
                            Descubrir formas de crecer con tus ingresos puede ser emocionante y
                            gratificante.
                        </p>
                    </Animated>

                    <Animated animation={'animate__fadeInDown animate__delay-4s'}>
                        <p>
                            La industria del taro en México ofrece una oportunidad única para
                            aquellos interesados en participar en la agricultura y contribuir al
                            crecimiento económico del país.
                        </p>
                    </Animated>

                    {/* <Animated animation={'animate__fadeInDown animate__delay-5s'}>
                        <p>
                            Aquí te presentamos algunas preguntas frecuentes que te ayudarán a
                            comprender cómo puedes ser parte de esta industria en auge:
                        </p>
                    </Animated> */}

                    {/* <Animated animation={'animate__fadeIn animate__delay-6s'}>
                        <Accordeon />
                    </Animated> */}
                </section>
                <section className="section__block">
                    <div className="picture">
                        <Animated animation={'animate__fadeInRight animate__delay-1s'}>
                            <img src={pictures} alt="pictures" />
                        </Animated>
                    </div>
                </section>
            </section>
        </main>
    );
}
